import { Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const SignUpInfo = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 40px;
  width: 458px;

  ${DEVICE.mobile.max} {
    padding: 24px;
    width: 100%;
  }
`;

const SignUpInfoGroup = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;

  ${DEVICE.mobile.max} {
    flex-direction: column;
  }

  &:last-child {
    ${DEVICE.mobile.max} {
      flex-direction: column-reverse;
    }
  }
`;

const SignUpInfoTerms = styled(Typography)`
  margin: 12px 0;
`;

const SignUpInfoTermsItem = styled.a`
  color: var(--color-fg-default);
  display: inline;
  text-decoration: underline;
  width: auto;
`;

export { SignUpInfo, SignUpInfoGroup, SignUpInfoTerms, SignUpInfoTermsItem };
